module.exports = __webpack_public_path__ + "static/pcr18-cis120-b4d83a9c9cd764ec04a03a8ae5e17f1d.png";